module.exports = __webpack_public_path__ + "img/history.f63dbe61.svg";